import React, { useState } from 'react';
import computer from '../assets/images/computer.png';
import { NewServiceList, ServicesList } from '../constant/Data';
import Modal from './reusable/Modal';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import { responsiveClassName } from '../utils/classNames';

const Services = () => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedNewSerivce, setSelectedNewService] = useState(null);
  const [isopenPopup, setIsOpenPopup] = useState(false);
  const [isOpenNewServicePopup, setIsOpenNewServicePopup] = useState(false);

  const handleClick = (item) => {
    setSelectedItem(item);
    setIsOpenPopup(true);
  };

  return (
    <section
      className={responsiveClassName(
        `container mx-auto px-4  grid grid-cols-1  items-center`,
        'container mx-auto px-15  grid grid-cols-2  items-center'
      )}
    >
      <div>
        <div
          className={responsiveClassName(
            'grid grid-cols-3 gap-4 cursor-pointer ',
            'justify-start gap-8  grid grid-cols-5 cursor-pointer'
          )}
        >
          {ServicesList.map((item, index) => {
            const Icon = item?.image;
            return (
              <div
                key={item?.title}
                className={tw`cursor-pointer text-center flex flex-col items-center max-w-27 text-base font-bold`}
                onClick={() => handleClick(item)}
              >
                <div className={tw`text-primary hover:text-primary-active`}>
                  <Icon />
                </div>
                <span>{item?.title}</span>
              </div>
            );
          })}
        </div>
        <div className={tw`w-full text-center col-span-5`}>
          <h3 className={tw`text-2xl font-bold  p-2 ml-4 `}>
            We're launching new features soon - stay tuned!
          </h3>
        </div>
        <div
          className={responsiveClassName(
            `justify-start gap-4 grid grid-cols-3 mt-4 cursor-pointer`,
            'justify-start gap-4 grid grid-cols-5 mt-4 cursor-pointer'
          )}
        >
          {NewServiceList.map((item, index) => {
            const Icon = item?.image;
            return (
              <div
                key={item?.title}
                className={tw`cursor-pointer px-3 flex flex-col items-center text-center text-base font-bold font-display text-customGreen`}
                onClick={() => {
                  setIsOpenNewServicePopup(!isOpenNewServicePopup);
                  setSelectedNewService(item);
                }}
              >
                <div className={tw`text-primary hover:text-primary-active`}>
                  <Icon />
                </div>
                <span>{item?.title}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className={tw`flex justify-end w-full`}>
        <img src={computer} alt='computer' className={tw`object-contain`} />
      </div>

      <Modal isOpen={isopenPopup} setIsOpen={setIsOpenPopup}>
        {selectedItem && (
          <div className=''>
            <div className={tw` relative rounded-lg `}>
              <div
                className={tw`bg-primary rounded-t-lg p-10 flex items-center justify-end`}
              ></div>

              <div
                className={tw`flex flex-col text-primary  items-center justify-center  inset-x-0 absolute -translate-y-10 `}
              >
                <selectedItem.image />
              </div>

              <div
                className={responsiveClassName(
                  `p-4 mt-6 shadow-[0px_1px_8px_0px_#00000040] rounded-b-lg  `,
                  'p-10 shadow-[0px_1px_8px_0px_#00000040] rounded-b-lg'
                )}
              >
                <h2
                  className={responsiveClassName(
                    `font-bold text-2xl leading-16 text-center`,
                    'font-bold text-3xl leading-16 text-center'
                  )}
                >
                  {selectedItem?.title}
                </h2>
                <p className={tw`leading-15 text-xl`}>
                  {selectedItem?.description}
                </p>
                <ul className={tw`list-disc pl-7 text-lg `}>
                  {selectedItem?.details.map((detail, idx) => (
                    <li key={idx}>
                      <p>
                        <strong>{detail.title}</strong>: {detail.description}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        )}
      </Modal>
      <Modal
        isOpen={isOpenNewServicePopup}
        setIsOpen={setIsOpenNewServicePopup}
      >
        {selectedNewSerivce && (
          <div className={tw`max-w-3xl h-full   relative rounded-lg `}>
            <div
              className={tw`bg-primary rounded-t-lg p-10 flex items-center justify-end `}
            ></div>
            <div
              className={tw`flex flex-col text-primary  items-center justify-center absolute inset-x-0  -translate-y-12   `}
            >
              <selectedNewSerivce.images />
            </div>

            <div
              className={tw`mt-[100px] shadow-[0px_1px_8px_0px_#00000040] rounded-b-lg flex justify-center items-center `}
            >
              <p className={tw`text-xl text-center `}>
                {selectedNewSerivce.description}
              </p>
            </div>
          </div>
        )}
      </Modal>
    </section>
  );
};

export default Services;
